(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-product-widget"]) return;
  try {
    
(function () {
  var widget = document.getElementById('article-product-widget');
  if (!widget) return;

  var track = widget.querySelector('#apw-track');
  var dots = widget.querySelectorAll('.apw__dot');
  var closeBtn = widget.querySelector('.apw__close');
  var expandBtn = widget.querySelector('.apw__tab');
  var panel = widget.querySelector('#apw-panel');
  var items = widget.querySelectorAll('.apw__item');
  var current = 0;
  var timer = null;
  var INTERVAL = 3500;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function goTo(index) {
    if (isDesktop()) return;
    current = (index + items.length) % items.length;
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
    dots.forEach(function (d, i) {
      d.classList.toggle('apw__dot--active', i === current);
    });
  }

  function startAuto() {
    if (isDesktop() || prefersReducedMotion) return;
    clearInterval(timer);
    timer = setInterval(function () { goTo(current + 1); }, INTERVAL);
  }

  function stopAuto() {
    clearInterval(timer);
  }

  function setMinimized(isMinimized) {
    widget.classList.toggle('is-minimized', isMinimized);
    closeBtn.setAttribute('aria-expanded', String(!isMinimized));
    expandBtn.setAttribute('aria-expanded', String(!isMinimized));
    panel.setAttribute('aria-hidden', String(isMinimized));

    if (isMinimized) {
      stopAuto();
    } else {
      startAuto();
    }

    try {
      sessionStorage.setItem('apw_minimized', isMinimized ? '1' : '0');
      sessionStorage.removeItem('apw_closed');
    } catch (e) {
      /* private browsing */
    }
  }

  /* -- Dot navigation -- */
  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      stopAuto();
      goTo(parseInt(dot.dataset.dot, 10));
      startAuto();
    });
  });

  /* -- Touch/swipe support -- */
  var touchStartX = 0;
  var touchDeltaX = 0;
  var isSwiping = false;
  var SWIPE_THRESHOLD = 40;

  track.addEventListener('touchstart', function (e) {
    if (isDesktop()) return;
    touchStartX = e.touches[0].clientX;
    touchDeltaX = 0;
    isSwiping = true;
    stopAuto();
  }, { passive: true });

  track.addEventListener('touchmove', function (e) {
    if (!isSwiping) return;
    touchDeltaX = e.touches[0].clientX - touchStartX;
  }, { passive: true });

  track.addEventListener('touchend', function () {
    if (!isSwiping) return;
    isSwiping = false;
    if (Math.abs(touchDeltaX) > SWIPE_THRESHOLD) {
      if (touchDeltaX < 0) {
        goTo(current + 1);
      } else {
        goTo(current - 1);
      }
    }
    startAuto();
  });

  /* -- Minimize/expand controls -- */
  closeBtn.addEventListener('click', function () {
    setMinimized(true);
  });

  expandBtn.addEventListener('click', function () {
    setMinimized(false);
  });

  /* -- Restore minimized state -- */
  try {
    if (sessionStorage.getItem('apw_minimized') === '1') {
      setMinimized(true);
    } else {
      setMinimized(false);
    }
  } catch (e) {
    startAuto();
  }

  /* -- Responsive handler -- */
  window.matchMedia('(min-width: 990px)').addEventListener('change', function () {
    stopAuto();
    if (!isDesktop() && !widget.classList.contains('is-minimized')) startAuto();
  });

  /* -- GA4 product click tracking -- */
  function trackProductClick(card) {
    var hasGtag = typeof window.gtag === 'function';
    var hasDataLayer = window.dataLayer && typeof window.dataLayer.push === 'function';
    if (!hasGtag && !hasDataLayer) return;

    var priceCents = parseInt(card.getAttribute('data-price-cents'), 10);
    var price = isNaN(priceCents) ? undefined : priceCents / 100;
    var position = parseInt(card.getAttribute('data-position'), 10);

    var item = {
      item_id: card.getAttribute('data-product-id') || '',
      item_name: card.getAttribute('data-product-title') || '',
      item_brand: card.getAttribute('data-product-vendor') || undefined,
      item_category: card.getAttribute('data-product-type') || undefined,
      price: price,
      currency: card.getAttribute('data-currency') || undefined,
      index: isNaN(position) ? undefined : position,
      item_list_id: 'article_product_widget',
      item_list_name: 'Article Product Widget'
    };

    var payload = {
      item_list_id: 'article_product_widget',
      item_list_name: 'Article Product Widget',
      blog_post: window.location.pathname,
      items: [item]
    };

    try {
      if (hasGtag) window.gtag('event', 'select_item', payload);
      if (hasDataLayer) {
        window.dataLayer.push({
          event: 'select_item',
          ecommerce: payload
        });
      }
    } catch (err) {
      /* analytics not ready */
    }
  }

  var cards = widget.querySelectorAll('.apw__card');
  cards.forEach(function (card) {
    card.addEventListener('click', function () {
      trackProductClick(card);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pop-up"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('newsletter-popup')) {
    class NewsletterPopup extends HTMLElement {
      static STORAGE_KEY = 'saklioda_newsletter_popup';

      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;

        this.delay = Number(this.dataset.delay || 0) * 1000;
        this.dismissDays = Number(this.dataset.dismissDays || 7);
        this.waitAge = this.dataset.waitAge === 'true';
        this.submitted = Boolean(this.querySelector('[data-state="success"], [data-state="error"]'));
        this.succeeded = Boolean(this.querySelector('[data-state="success"]'));

        this.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', () => this.close()));
        this.querySelector('[data-close-link]')?.addEventListener('click', () => this.close());
        this.querySelector('[data-copy]')?.addEventListener('click', (event) => this.copyCode(event.currentTarget));
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close();
        });

        if (this.succeeded) this.remember({ subscribed: true });

        if (window.Shopify?.designMode) {
          this.setupEditor();
          return;
        }

        // Form gönderildikten sonra sayfa yenilenir: sonucu hemen göster.
        if (this.submitted) {
          this.open();
          return;
        }

        if (!this.shouldShow()) return;
        this.whenAgeVerified(() => {
          this.timer = setTimeout(() => this.open(), this.delay);
        });
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        clearInterval(this.ageInterval);
      }

      setupEditor() {
        const sectionId = this.dataset.sectionId;
        if (this.dataset.preview === 'true') this.open();
        this.onSelect = (event) => {
          if (event.detail.sectionId === sectionId) this.open();
        };
        this.onDeselect = (event) => {
          if (event.detail.sectionId === sectionId) this.dialog.close();
        };
        document.addEventListener('shopify:section:select', this.onSelect);
        document.addEventListener('shopify:section:deselect', this.onDeselect);
      }

      shouldShow() {
        const state = this.read();
        if (state.subscribed) return false;
        if (state.dismissedUntil && state.dismissedUntil > Date.now()) return false;
        return true;
      }

      // Yaş doğrulama uygulaması doğrulamayı "age_verified_<id>" anahtarıyla
      // sessionStorage'a ("true") ya da localStorage'a ({ expiry }) yazar.
      isAgeVerified() {
        try {
          for (let i = 0; i < sessionStorage.length; i++) {
            if (sessionStorage.key(i).startsWith('age_verified_')) return true;
          }
          for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (!key.startsWith('age_verified_')) continue;
            const { expiry } = JSON.parse(localStorage.getItem(key)) || {};
            if (expiry > Date.now()) return true;
          }
        } catch (error) {
          return false;
        }
        return false;
      }

      whenAgeVerified(callback) {
        const root = document.getElementById('age-verification-root');
        if (!this.waitAge || !root || this.isAgeVerified()) {
          callback();
          return;
        }

        const startedAt = Date.now();
        this.ageInterval = setInterval(() => {
          // Uygulama bu sayfada doğrulama penceresi açmadıysa (kök boş kaldıysa) beklemeyi bırak.
          const gateMissing = Date.now() - startedAt > 4000 && root.childElementCount === 0;
          if (this.isAgeVerified() || gateMissing) {
            clearInterval(this.ageInterval);
            callback();
          }
        }, 500);
      }

      open() {
        if (this.dialog.open) return;
        this.dialog.showModal();
      }

      close() {
        if (!this.dialog.open) return;
        this.dialog.close();
        if (window.Shopify?.designMode || this.succeeded) return;
        this.remember({ dismissedUntil: Date.now() + this.dismissDays * 86400000 });
      }

      async copyCode(button) {
        const code = this.querySelector('[data-code]')?.textContent.trim();
        if (!code) return;
        try {
          await navigator.clipboard.writeText(code);
          const original = button.textContent;
          button.textContent = button.dataset.copiedLabel || original;
          setTimeout(() => (button.textContent = original), 2000);
        } catch (error) {
          window.getSelection()?.selectAllChildren(this.querySelector('[data-code]'));
        }
      }

      read() {
        try {
          return JSON.parse(localStorage.getItem(NewsletterPopup.STORAGE_KEY)) || {};
        } catch (error) {
          return {};
        }
      }

      remember(data) {
        try {
          localStorage.setItem(NewsletterPopup.STORAGE_KEY, JSON.stringify({ ...this.read(), ...data }));
        } catch (error) {}
      }
    }

    customElements.define('newsletter-popup', NewsletterPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
